import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { UsersService } from '../../../../services/users.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { Subject } from 'rxjs';
import { CreateEditUserComponent } from './create-edit-user/create-edit-user.component';
import { CustomersService } from '../../../../services/customers.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {

dtConfig = {
    config: {
        base: this.usersService,
        hasCustomProcessData: true,
		processValues: (response) => {
			response.data.map((user: any) => {
				user.roles = user.roles[0]; // para acceso más fácil
				user.role_id = user.roles?.id ?? null; // para el dropdown
				user.client_real_id = user.client_id; // guarda el id real
				user.client_id = this.clientMap.get(user.client_id) || 'Cliente no asociado'; // visualización
				return user;
			});
			return response;
		},
        api: 'datatable',
        rowsPerPage: 10,
        order: [[2, 'desc']],
        params: {
            key: ''
        }
    },
    columns: [
        {
            title: 'ID',
            field: 'id'
        },
        {
            title: 'Nombre',
            field: 'name',
        },
        {
            title: 'Correo',
            field: 'email',
        },
        {
            title: 'Empresa',
            field: 'client_id',
        },
        {
            title: 'Rol de usuario',
            field: 'roles.name',
        }
    ],
    actions: [
        {
            display: 'Editar',
            icon: 'fa-pencil',
            event: 'reel-categories.edit',
            conditionality: 'true'
        },
        {
            display: 'Eliminar',
            icon: 'fa-trash',
            event: 'reel-categories.delete',
            conditionality: 'true'
        }
    ]
};

	private atComponentDestroy = new Subject();
	private clientMap = new Map<number, string>();

	constructor(
		private usersService: UsersService,
		private swal: SwalService,
		private broadcast: BroadcastService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private nrModal: NRModalService,
		private customersService: CustomersService
	) { }

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

	async ngOnInit(): Promise<void> {
		let clientsResponse = await this.customersService.getAll();
		let clients = clientsResponse.data ?? [];

		// Crear un mapa de clientes basado en client_id para acceso rápido
		this.clientMap = new Map(clients.map(client => [client.id, client.name]));

		this.broadcast
			.onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((event: EventModel) => {
				const props = this.prepareProps(event);
				if (props) {
					this.nrModal.open(props, 'md');
				}
			});
	}

	/**
	 * Prepare the User data for the modal window
	 * @param event
	 * @returns
	 */
	prepareProps(event: EventModel): any {
		const props: DynamicHostModel = new DynamicHostModel();
		props.instantiated = false;
		props.modalModel = {
			component: null,
			componentFactoryResolver: this.componentFactoryResolver,
			data: {
				client_id: event.name === 'reel-categories.edit' ? event.data.item?.client_real_id : null,
				role_id: event.name === 'reel-categories.edit' ? event.data.item?.roles?.id ?? null : null,
				...event.data.item
			}
		};

		switch (event.name) {
			case 'reel-categories.add':
				props.modalModel.component = CreateEditUserComponent;
				props.modalModel.modalConfiguration = {
					title: 'Agregar Usuario'
				};
				break;
			case 'reel-categories.edit':
				props.modalModel.component = CreateEditUserComponent;
				props.modalModel.modalConfiguration = {
					title: 'Editar Usuario'
				};
				break;
			case 'reel-categories.delete':
				this.delete(event.data);
				return false;
		}

		return props;
	}

	/**
	 * Open ADD modal window
	 */
	add(): void {
		this.broadcast.fire({
			name: 'reel-categories.add',
			type: EventType.MODAL,
			data: {}
		});
	}

	/**
	 * Get User confirmation and send the signal to the server
	 * @param data
	 */
	delete(data): void {
		const swalParams = {
			title: '¿Estás seguro de querer eliminar el usuario?'
		};

		this.swal.warning(swalParams).then(result => {
			if (result.value) {
				this.usersService.delete(data.item.id).subscribe((resp: any) => {
					if (resp.success) {
						this.swal.success({ title: 'Usuario eliminado exitosamente' }).then(() => {
							this.broadcast.reloadDataTable();
						});
					} else {
						this.swal.error('Ocurrio un error al intentar borrar el usuario');
					}
				});
			}
		});
	}
}
